import { Typography } from "@mui/material";
import React from "react";
import { GROUP_BY_TYPES } from "../../../../data/constants";
import { currency } from "../../../../helpers/common-helper";

const currencySymbol = currency();
 {/* function to Handle all the cases before and after sorting*/} 
function getHeaderText(headerData: any) {
  const isBranchGrouping = headerData.groupBy === GROUP_BY_TYPES.branch;
  const hasMultipleHeaderNames = headerData?.headerName?.length > 1;

  if (isBranchGrouping) {
    if (hasMultipleHeaderNames) {
      return headerData.headerName;
    } else {
      const branchId = headerData?.option[0]?.branchId;
      return headerData?.businessBranchesDataMap[branchId]?.branchName;
    }
  } else {
    return hasMultipleHeaderNames
      ? headerData.headerName
      : headerData?.option[0]?.bizBrandName;
  }
}

 export function renderAccordionHeader(headerData: any): React.JSX.Element {
    return (
      <div className="w-full flex smd:!pr-0">
        <Typography
          component={"span"}
          className="flex items-center !m-0 justify-between w-full"
        >
          <div className="flex flex-col">
            <div className="flex items-center">
              <span className={`text-[15px] capitalize font-medium`}>
                {getHeaderText(headerData)}
                               </span>
            </div>
            <div className="flex items-center">
              <span
                className={`text-[13px] capitalize font-medium text-[#0000007A]`}
              >
                {headerData?.itemCount}
              </span>
              <span
                className={`ml-5 text-[13px] capitalize font-medium text-[#0000007A]`}
              >
                {"customers"}
              </span>
            </div>
          </div>
          <div className="text-[14px] smd:pr-[12px] text-[#3A5E8B] ">
            <span>Amount Receivable:</span>
            <span className="ml-5 font-semibold">{currencySymbol}{Number(headerData?.itemPrice).toFixed(2)}</span>
          </div>
        </Typography>
      </div>
    );
  }